'use strict';

export const INT_MAX = 2147483647;

export function isNumber(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}